<template>
  <vs-row>
    <vs-col class="order-wrapper" vs-offset="1" vs-type="flex" vs-justify="center"
            vs-align="center" vs-w="10">
      <vs-row style="width: 100%;">
        <vs-row vs-type="flex" vs-justify="flex-end" vs-align="right">
          <strong>
            <p class="policy">
              <a href="https://beregszaszietterem.hu/etelrendeles/assets/files/cronga_team_kft_adatvedelmi_es_adatbiztonsági_szabalyzat.pdf"
                 target="_blank">Adatvédelmi tájékoztató</a>
            </p>
            <p class="policy">
              <a href="https://beregszaszietterem.hu/etelrendeles/assets/files/PaymentService_Fizetesi_tajekoztato.pdf"
                 target="_blank">SimplePay fizetési tájékoztató</a>
            </p>
            <p class="policy">
              <a href="https://beregszaszietterem.hu/etelrendeles/assets/files/SimplePay_b2c_aff_hun_eng_20190926.pdf"
                 target="_blank">SimplePay ÁFF</a>
            </p>
          </strong>
          <a href="tel:+36302773219">
            <vs-button class="phone-button"  size="large">
              Rendelj MOST! <vs-icon icon="phone" align="right" style="margin-left: 10px; font-size:1.8rem;"></vs-icon>
            </vs-button>
          </a>
        </vs-row>
        <vs-row vs-justify="center">
          <a href="https://beregszaszietterem.hu">
            <img id="top_of_the_page" class="logo" :src="require('@/assets/images/logo/beregsz_logo.png')" alt="Logo">
          </a>
          <vs-row vs-type="flex" vs-w="12" vs-justify="center" style="margin-top: 15px;">
            <vs-col vs-lg="7" vs-sm="10" vs-type="flex" vs-justify="center">
              <vs-alert color="primary">
                <vs-row vs-type="flex" vs-justify="center">
                  <p class="alertText red">
                    <strong><u>Ételrendelés</u></strong>
                  </p>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="center">
                    <strong>+36/30-277-3219</strong>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="center"><p class="alertText">Tárgynapra vonatkozó,
                  Hajdúböszörmény
                  városán kívüli megrendelés
                  esetén is hívhatja a fenti
                  telefonszámot!</p>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="center">
                  <p class="alertText red">
                    <strong>Ételkiszállítás minden nap 12:00 órától!</strong>
                  </p>
                </vs-row>
              </vs-alert>
            </vs-col>
          </vs-row>
          <vs-divider></vs-divider>
        </vs-row>

        <cart @deleteFromCart="modifyLimit" @orderDone="modifyLimit" class="cart" v-bind:itemToCart="itemToCart"
              v-bind:menuSettings="menuSettings"></cart>
        <vs-row class="menuPosts">
          <transition appear name="fade" mode="out-in">
            <ul>
              <li class="post" v-for="(menuItem, itemIndex) in menuList" :key="itemIndex"
                  @click="getMenuItems(menuItem.Id, menuItem.PickupOnly, menuItem.MaxOrderHour, menuItem.ClosestDelivery, menuItem.WithBox)">
                <vs-button type="line" line-origin="left" style="background: rgba(84, 42, 41, 0.15);">
                  <strong>{{ menuItem.MenuName }}</strong>
                </vs-button>
              </li>
              <li class="post" @click="showDailyMenus()">
                <vs-button type="line" line-origin="left" style="background: rgba(84, 42, 41, 0.15);">
                  <strong>Napi menü</strong>
                </vs-button>
              </li>
              <li class="post" @click="getInfoText()">
                <vs-button type="line" line-origin="left" style="background: rgba(84, 42, 41, 0.15);">
                  <strong>Rendelési információk</strong>
                </vs-button>
              </li>
            </ul>
          </transition>
        </vs-row>

        <vs-row v-if="categories.length && (!showInfo && !showDaily && !showChildren)">
          <vs-row vs-type="flex" v-if="parseInt(selectedMenu) !== 30" vs-w="12" vs-justify="center"
                  style="margin-bottom: 25px; margin-top: 15px;">
            <vs-col vs-lg="7" vs-sm="10" vs-type="flex" vs-justify="center">
              <vs-alert color="primary">
                <vs-row vs-type="flex" vs-justify="center"><p class="alertText">{{ menuInfoText }}</p>
                </vs-row>
              </vs-alert>
            </vs-col>
          </vs-row>
          <vs-row>

        
        
          </vs-row>
          <div :key="forceRender" style="width: 100%;">
            <vs-col class="select-col">
              <select v-if="isMobile" v-model="selectedCategory" @change="selectTab">
                <option value="Mind">Összes</option>
                <option v-for="(submenu, submenuIndex) in categories" :key="submenuIndex" :value="submenu">
                  {{ submenu }}
                </option>
              </select>

            </vs-col>
            <transition appear name="fade" mode="out-in"> 
              <vs-tabs position="left" class="menu-tab" v-if="categories.length > 1 && !isMobile">
                <vs-tab label="Összes" @click="selectedCategory = 'Mind'"> 
                  <!-- has categories -->
                  <vs-row v-if="selectedCategory === 'Mind'" vs-type="flex" vs-justify="flex-start" vs-w="12">
                    <vs-col :key="itemIndex"
                            v-for="(menuItem, itemIndex) in selectedCategoryList"
                            :label="menuItem.ItemName"
                            vs-lg="3"
                            vs-sm="12"
                            class="cardx" vs-type="flex">
                      <vs-card class="cardx" fixed-height actionable style="box-shadow: 0 0 3px 0 #000">
                        <div slot="media">
                          <img class="itemImage" :src="$root.imagePath + menuItem.ItemFileName" alt="Image">
                        </div>
                        <vs-row style="position: relative;">
                          <div class="price" style="position: absolute; bottom: 5px; right: -5px;">
                            <vs-chip color="lightgreen" style="color: darkgreen; box-shadow: 0 0 0 5px #fff;">
                              {{ menuItem.ItemPrice }} HUF
                            </vs-chip>
                          </div>
                        </vs-row>
                        <vs-row>
                          <h5 class="breakWord">{{ menuItem.ItemName }}</h5>
                        </vs-row>
                        <p class="itemDesc"> {{ menuItem.ItemDescription }}</p>
                        <vs-row>
                          <p :key="Labelindex"
                             v-for="(itemLabels, Labelindex) in menuItem.ItemLabels">
                            <vs-chip color="success">{{ itemLabels.LabelName }}</vs-chip>
                          </p>
                        </vs-row>
                        <div slot="footer">
                          <div v-if="menuItem.Children.length === 0">
                            <vs-button
                                color="primary"
                                size="small" icon="shopping_cart" @click="viewDetails(menuItem)">
                              Kosárba
                            </vs-button>
                          </div>
                          <div v-else>
                            <vs-row vs-justify="flex-end">
                              <vs-button
                                   :disabled="parseInt(limitCartToCategory) !== -1 && parseInt(limitCartToCategory) !== 30 || disableShopping" 
                                  color="primary"
                                  size="small" icon="add_shopping_cart" @click="viewChildren(menuItem)">
                                Összeállítás
                              </vs-button>
                            </vs-row>
                          </div>
                        </div>
                      </vs-card>
                    </vs-col>
                  </vs-row>
                </vs-tab>
                <vs-tab :key="submenuIndex" v-for="(submenu, submenuIndex) in categories"
                        :label="submenu" @click="selectedCategory = submenu" class="menu-tab">
                  <vs-row vs-type="flex" style="" vs-justify="flex-start">
                    <vs-col :key="itemIndex"
                            v-for="(menuItem, itemIndex) in selectedCategoryList"
                            :label="menuItem.ItemName"
                            vs-lg="3"
                            vs-sm="12" class="cardx">
                      <vs-card fixed-height actionable style="box-shadow: 0 0 3px 0 #000;">
                        <div slot="media"><img class="itemImage"
                                               :src="$root.imagePath + menuItem.ItemFileName"
                                               alt="Image"></div>
                        <vs-row style="position: relative;">
                          <div class="price" style="position: absolute; bottom: 5px; right: -5px;">
                            <vs-chip color="lightgreen" style="color: darkgreen; box-shadow: 0 0 0 5px #fff;">
                              {{ menuItem.ItemPrice }} HUF
                            </vs-chip>
                          </div>
                        </vs-row>
                        <vs-row>
                          <h5>{{ menuItem.ItemName }}</h5>
                        </vs-row>
                        <p class="itemDesc"> {{ menuItem.ItemDescription }}</p>
                        <vs-row>
                          <p :key="Labelindex"
                             v-for="(itemLabels, Labelindex) in menuItem.ItemLabels">
                            <vs-chip color="success">{{ itemLabels.LabelName }}</vs-chip>
                          </p>
                        </vs-row>
                        <div slot="footer">
                          <div v-if="menuItem.Children.length === 0">
                            <vs-row vs-justify="flex-end">
                              <vs-button
                                  :disabled="parseInt(limitCartToCategory) === 30 || disableShopping"
                                  type="gradient" color="primary" size="small"
                                  icon="shopping_cart" @click="viewDetails(menuItem)">Kosárba
                              </vs-button>
                            </vs-row>
                          </div>
                          <div v-else>
                            <vs-row vs-justify="flex-end">
                              <vs-button
                                  :disabled="(limitCartToCategory) !== -1 && parseInt(limitCartToCategory) !== 30 || disableShopping"
                                  color="primary"
                                  size="small" icon="add_shopping_cart" @click="viewChildren(menuItem)">
                                Összeállítás
                              </vs-button>
                            </vs-row>
                          </div>
                        </div>
                      </vs-card>
                    </vs-col>
                  </vs-row>
                </vs-tab>
              </vs-tabs>

              <!-- no categories -->
              <vs-row v-else>
                <vs-row v-if="parseInt(selectedMenu) === 30" vs-type="flex" vs-w="12" vs-justify="center">
                  <h5>Válasszon hidegtálaink közül, vagy állítson össze egyet saját ízlése
                    szerint!</h5>
                </vs-row>
                <vs-row vs-type="flex" v-if="parseInt(selectedMenu) === 30" vs-w="12" vs-justify="center"
                        style="margin-bottom: 25px; margin-top: 15px;">
                  <vs-col vs-lg="7" vs-sm="10" vs-type="flex" vs-justify="center">
                    <vs-alert color="primary">
                      <vs-row vs-type="flex" vs-justify="center"><p class="alertText">{{ menuInfoText }}</p>
                      </vs-row>
                    </vs-alert>
                  </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="flex-start" vs-w="12">
                  <vs-col :key="itemIndex"
                          v-for="(menuItem, itemIndex) in selectedCategoryList"
                          :label="menuItem.ItemName"
                          vs-lg="3"
                          vs-sm="12" class="cardx">
                    <vs-card fixed-height actionable style="box-shadow: 0 0 3px 0 #000;">
                      <div slot="media">
                        <img class="itemImage" :src="$root.imagePath + menuItem.ItemFileName" alt="Image">
                      </div>
                      <vs-row style="position: relative;">
                        <div class="price" style="position: absolute; bottom: 5px; right: -5px;">
                          <vs-chip color="lightgreen" style="color: darkgreen; box-shadow: 0 0 0 5px #fff;">
                            {{ menuItem.ItemPrice > 0 ? menuItem.ItemPrice + ' HUF' : 'Változó' }}
                          </vs-chip>
                        </div>
                      </vs-row>
                      <vs-row>
                        <h5>{{ menuItem.ItemName }}</h5>
                      </vs-row>
                      <p class="itemDesc"> {{ menuItem.ItemDescription }}</p>
                      <vs-row>
                        <p :key="Labelindex"
                           v-for="(itemLabels, Labelindex) in menuItem.ItemLabels">
                          <vs-chip color="success">{{ itemLabels.LabelName }}</vs-chip>
                        </p>
                      </vs-row>
                      <div slot="footer">
                        <div v-if="menuItem.Children.length === 0">
                          <vs-button
                              color="primary"
                              size="small" icon="shopping_cart" @click="viewDetails(menuItem)">
                            Kosárba
                          </vs-button>
                        </div>
                        <div v-else>
                          <vs-button
                              :disabled="(limitCartToCategory) !== -1 && parseInt(limitCartToCategory) !== 33 || disableShopping"
                              color="primary"
                              size="small" icon="add_shopping_cart" @click="viewChildren(menuItem)">
                            Összeállítás
                          </vs-button>
                        </div>
                      </div>
                    </vs-card>
                  </vs-col>
                </vs-row>
              </vs-row>
            </transition>
          </div>
        </vs-row>
        <!-- child elements -->
        <transition name="fade" mode="out-in">
          <vs-row v-if="showChildren">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" style="margin-bottom: 15px;">
              <h3>Válassza ki az összetevőket:</h3>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" style="margin-bottom: 45px;">
              <p>Csomagolási díj sültenként <b>40 Ft</b>, saláta adagonként <b>300 Ft</b>  <br/> </p>  
            </vs-row>
            <vs-row vs-type="flex" vs-justify="flex-start" vs-w="12">
              <vs-col :key="childIndex"
                      v-for="(child, childIndex) in childrenList"
                      :label="child.ItemName"
                      vs-lg="3"
                      vs-sm="12" class="cardx noMedia">
                <vs-card fixed-height actionable style="box-shadow: 0 0 3px 0 #000;">
                  <vs-row style="position: relative;">
                    <div class="price" style="position: absolute; bottom: 5px; right: -5px;">
                      <vs-chip color="lightgreen" style="color: darkgreen; box-shadow: 0 0 0 5px #fff;">
                        {{ child.ItemPrice }} HUF
                      </vs-chip>
                    </div>
                  </vs-row>
                  <vs-row>
                    <h5>{{ child.ItemName }}</h5>
                  </vs-row>
                  <p class="itemDesc"> {{ child.ItemDescription }}</p>
                  <vs-row>
                    <p :key="Labelindex"
                       v-for="(itemLabels, Labelindex) in child.ItemLabels">
                      <vs-chip color="success">{{ itemLabels.LabelName }}</vs-chip>
                    </p>
                  </vs-row>
                  <div slot="footer">
                    <vs-button
                        :disabled="parseInt(limitCartToCategory) !== -1 && parseInt(limitCartToCategory) !== 33"
                        color="primary"
                        size="small" icon="shopping_cart" @click="viewDetails(child)">Kosárba
                    </vs-button>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-row>
        </transition>
        <!-- daily menu elements -->
        <transition name="fade" mode="out-in">
          <vs-row v-if="showDaily">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <h5>Válasszon napi menüink közül!</h5>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center"
                    style="margin-bottom: 25px; margin-top: 15px;">
              <vs-col vs-lg="7" vs-sm="10" vs-type="flex" vs-justify="center">
                <vs-alert color="primary">
                  <vs-row vs-type="flex" vs-justify="center"><p class="alertText"> {{ dailyMenuText }}</p>
                  </vs-row>
                </vs-alert>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="flex-start" vs-w="12">
              <vs-col :key="dailyIndex"
                      v-for="(daily, dailyIndex) in dailyMenuList"
                      :label="daily.MenuDate"
                      vs-lg="3"
                      vs-sm="12" class="cardx noMedia">
                <vs-card fixed-height actionable style="box-shadow: 0 0 3px 0 #000; min-height: 150px;">
                  <vs-row>
                    <h5>{{ formatDate(daily.MenuDate) }}</h5>
                  </vs-row>
                  <div class="itemDesc">
                    <span v-if="daily.IdMainA">
                      <strong>"A" menü:</strong> {{ daily.MainAName }}<br/>
                    </span>
                    <span v-if="daily.IdMainB">
                      <strong>"B" menü:</strong> {{ daily.MainBName }}<br/>
                    </span>
                    <span v-if="daily.IdMainC">
                      <strong>"Tej- és cukormentes" menü:</strong> {{ daily.MainCName }}<br/>
                    </span>
                    <span v-if="daily.IdDiet">
                      <strong>"Epe kímélő" menü:</strong> {{ daily.DietName }}<br/>
                    </span>
                    <span v-if="daily.IdExtra">
                      <strong>Extra: </strong> {{ daily.ExtraName }}<br/>
                    </span>
                  </div>
                  <div slot="footer">
                    <vs-button
                        color="primary"
                        size="small" icon="shopping_cart" @click="addToCartDaily(daily)"
                        :disabled="parseInt(limitCartToCategory) === 30 || disableShopping">Kosárba
                    </vs-button>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-row>
        </transition>

        <!-- information -->
        <transition name="fade" mode="out-in">
          <vs-row v-if="showInfo" vs-type="flex">
            <vs-col vs-w="10" vs-offset="1" vs-type="flex">
              <div v-html="infoText.OptionValue"/>
            </vs-col>
          </vs-row>
        </transition>
        <vs-divider/>
        <vs-row class="footer" vs-w="12">
          <vs-col vs-w="12" vs-justify="center">
            <h4>Elérhetőség</h4>
            <p>+36 / 30 - 277 - 3219<br>
              iroda@beregszaszietterem.hu
            </p>
          </vs-col>
        </vs-row>
        <vs-row class="footer">
          <back-to-top bottom="50px" right="50px">
            <button type="button" class="btn btn-secondary btn-to-top" icon="expand_less">^</button>
          </back-to-top>
          <vs-col vs-justify="center" vs-align="center" vs-type="flex">
            <p>
              Beregszászi Étterem és Rendezvényház &copy; {{ new Date().getFullYear() }} 
              <strong><a
                  href="https://beregszaszietterem.hu/etelrendeles/assets/files/cronga_team_kft_adatvedelmi_es_adatbiztonsági_szabalyzat.pdf"
                  target="_blank">Adatvédelmi tájékoztató</a></strong> | Powered by
              <strong>
                <a href="https://www.cts.hu"> CTS-Informatika Kft. </a>
              </strong>
            </p>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-col>
    <div class="centerx">
      <vs-popup title="Kosárba helyezés" :active.sync="addToCartModal"
                @addToCartEvent="addToCart">
        <add_to_cart v-bind:selectedItem="selectedItem" v-bind:box="menuSettings.box"
                     v-bind:boxPrice="boxPrice"></add_to_cart>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup title="Kosárba helyezés" :active.sync="addToCartDailyModal"
                @addToCartEvent="addToCart">
        <add_to_cart_daily v-bind:selectedDailyItem="selectedItem" v-bind:boxPrice="boxPrice"></add_to_cart_daily>
      </vs-popup>
    </div>
    <vue-cookie-accept-decline
        :ref="'cookiePanel'"
        :elementId="'cookiePanel'"
        :debug="false"
        :position="'bottom'"
        :type="'bar'"
        :disableDecline="false"
        :transitionName="'slideFromBottom'"
        :showPostponeButton="false">
      <div slot="postponeContent">
        &times;
      </div>
      <div slot="message">
        <p>A cookie egy apró, a honlapunkról elküldött adat, amit az Ön böngésző programja, mobiltelefonja vagy más
          eszköze tárol, amíg Ön a honlapunkat használja. Ennek révén a következő látogatáskor a honlap felismeri a
          készülékét, hozzáférést biztosít bizonyos funkciókhoz, és megérti, milyen logika szerint használja a honlapot.
          A weboldal sütiket használ a megrendelési adatok tárolásához. Erről bővebben az <strong><a
              href="https://beregszaszietterem.hu/etelrendeles/assets/files/cronga_team_kft_adatvedelmi_es_adatbiztonsági_szabalyzat.pdf"
              target="_blank">Adatvédelmi tájékoztató</a></strong>ban olvashat.</p>
      </div>
      <div slot="declineContent">
        Elutasítom
      </div>
      <div slot="acceptContent">
        Elfogadom
      </div>
    </vue-cookie-accept-decline>

  </vs-row>
  
</template>

<script>

import {axiosInstance} from "@/main";
import cart from "../../components/cart/cart";
import add_to_cart from "../../components/cart/add_to_cart";
import add_to_cart_daily from "../../components/cart/add_to_cart_daily";
import dayjs from "dayjs";
import 'dayjs/locale/hu';
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import BackToTop from 'vue-backtotop'

export default {
  name: "order",
  components: {cart, add_to_cart, add_to_cart_daily, VueCookieAcceptDecline, BackToTop},
  data() {
    return {
      disableShopping: false,
      addToCartModal: false,
      addToCartDailyModal: false,
      showChildren: false,
      showDaily: false,
      showInfo: false,
      menuList: [],
      menuListItems: [],
      childrenList: [],
      dailyMenuList: [],
      forceRender: 0,
      menuSettings: {
        pickupOnly: 0,
        maxHour: 20,
        closestDelivery: 'today',
        box: true,
      },
      selectedMenu: -1,
      limitCartToCategory: -1,
      cartLength: 0,
      categories: [],
      selectedCategory: 'Mind',
      selectedItem: null,
      selectedCategoryList: [],
      itemToCart: {},
      infoText: '',
      boxPrice: 0,
      dailyMenuText: ''
    }
  },
  computed: {
    menuInfoText: function () {
      return this.menuList.find(x => x.Id == this.selectedMenu).InfoText;
    },
    isMobile() {
      // Detects if the screen width is 768px or less
      return window.innerWidth <= 768;
    }
    
  },
  watch: {
    menuListItems() {
      if (this.menuListItems.length > 0) {
        this.categories = [...new Set(this.menuListItems.map(elem => elem.ItemCategory.CategoryName))];
      }
    },
    '$route.hash': function (newHash) {
    if (newHash === '#napimenu') {
      this.showDailyMenus();
    }
  },
  selectedCategory() {
    if (this.selectedCategory === 'Mind') {
      // Create a new array and sort it
      this.selectedCategoryList = [...this.menuListItems].sort((a, b) => 
        a.ItemCategory.categoryOrder - b.ItemCategory.categoryOrder
      );
    } else {
      // Filter and sort
      this.selectedCategoryList = this.menuListItems
        .filter(elem => elem.ItemCategory.CategoryName === this.selectedCategory)
        .sort((a, b) => a.ItemCategory.categoryOrder - b.ItemCategory.categoryOrder);
    }
  },
    categories() {
      this.forceRender += 1;
    }
  },
  
  methods: {
    getMenuList() {
      let self = this;
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      axiosInstance
          .get('public/menuController.php')
          .then((resp) => {
            self.menuList = resp.data.responseData;
            self.getMenuItems(self.menuList[0].Id, self.menuList[0].PickupOnly, self.menuList[0].MaxOrderHour, self.menuList[0].ClosestDelivery, self.menuList[0].WithBox);
            self.showChildren = false;
            self.$vs.loading.close();
          });
    },
    selectTab() {
      this.selectedCategory == "";
      if (this.selectedCategory === 'Mind') 
        this.selectedCategoryList = this.menuListItems;
      else
        this.selectedCategoryList = this.menuListItems.filter(elem => elem.ItemCategory.CategoryName === this.selectedCategory);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getMenuItems(id, pickuponly, maxHour, closestDelivery, box) {
      let self = this;
      this.menuSettings = {
        pickupOnly: pickuponly,
        maxHour: maxHour,
        closestDelivery: closestDelivery,
        box: parseInt(box)
      }
      this.selectedMenu = id;
      this.showChildren = false;
      this.showDaily = false;
      this.showInfo = false;
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      axiosInstance.get('public/orderingMenuItemsController.php?menuId=' + id)
          .then((resp) => {
            //self.menuListItems = resp.data.responseData;
            self.menuListItems = resp.data.responseData.sort((a, b) => b.stickyColumn - a.stickyColumn);            
            self.selectedCategoryList = resp.data.responseData.sort((a, b) => a.categoryOrder - b.categoryOrder);
            self.selectedCategory = 'Mind';
            self.$vs.loading.close();
          });
    },
    viewDetails(item) {
      this.selectedItem = item;
      if (!item.ItemMenu) {
        item.ItemMenu = {};
        item.ItemMenu.MenuId = this.selectedMenu;
      }
      this.addToCartModal = true;
    },
    addToCart(payload) {
      payload.MaxOrderHour = this.menuSettings.maxHour;
      this.cartLength++;
      this.limitCartToCategory = payload.MenuId;
      this.itemToCart = payload;

      this.addToCartModal = false;
      this.addToCartDailyModal = false;
    },
    modifyLimit() {
      this.cartLength--;
      if (this.cartLength === 0)
        this.limitCartToCategory = -1;
    },
    viewChildren(item) {
      this.showChildren = true;
      this.menuListItems = [];
      this.childrenList = item.Children;
    },
    showDailyMenus() {
      let self = this;
      this.showChildren = false;
      this.showInfo = false;
      this.showDaily = true;
      this.menuListItems = [];
      this.selectedMenu = 'daily';
      this.menuSettings.pickupOnly = 1;
      
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      axiosInstance
          .get("public/dailyMenuController.php?order=true&date=" + dayjs().format('YYYY-MM-DD'))
          .then((resp) => {
            self.dailyMenuList = resp.data.responseData;
            self.$vs.loading.close();
          });
    },
    formatDate(date) {
      return dayjs(date).locale('hu').format('YYYY. MMMM. D. - dddd');
    },
    addToCartDaily(payload) {
      this.addToCartDailyModal = true;
      this.selectedItem = {...payload};
    },
    getInfoText() {
      let self = this;
      axiosInstance
          .get('public/optionsController.php?name=informationText')
          .then((resp) => {
            self.infoText = resp.data.responseData[0];
            self.showChildren = false;
            self.showDaily = false;
            self.showInfo = true;
          });
    },
    getBoxPrice() {
      let self = this;
      axiosInstance
          .get('public/optionsController.php?name=boxPrice')
          .then((resp) => {
            self.boxPrice = parseInt(resp.data.responseData[0].OptionValue);
          })
    },
    getDailyMenuText() {
      let self = this;
      axiosInstance
          .get('public/optionsController.php?name=dailyMenuText')
          .then((resp) => {
            self.dailyMenuText = resp.data.responseData[0].OptionValue;
          })
        },
    checkHashAndNavigate() {
      console.log('Checking hash:', window.location.hash);
  if (window.location.hash === '#napimenu') {
    console.log('Hash matches #napimenu, showing daily menus');
    this.showDailyMenus();
  }
    }
  },
  mounted() {
    this.checkHashAndNavigate();
    window.addEventListener("hashchange", this.checkHashAndNavigate);
  },
  created() {
    this.getMenuList();
    this.getBoxPrice();
    this.getDailyMenuText();
  }
}
</script>

<style scoped>

*, html {

  scroll-behavior: smooth !important;
}
.cardx {
  margin-bottom: 25px;
  min-width: 150px;
  width: 100%;
}




.noMedia {
  margin-bottom: 40px;
}

.order-wrapper {
  background-color: rgba(255, 255, 255, 1);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 40' width='80' height='40'%3E%3Cpath fill='%23eaddc5' fill-opacity='0.25' d='M0 40a19.96 19.96 0 0 1 5.9-14.11 20.17 20.17 0 0 1 19.44-5.2A20 20 0 0 1 20.2 40H0zM65.32.75A20.02 20.02 0 0 1 40.8 25.26 20.02 20.02 0 0 1 65.32.76zM.07 0h20.1l-.08.07A20.02 20.02 0 0 1 .75 5.25 20.08 20.08 0 0 1 .07 0zm1.94 40h2.53l4.26-4.24v-9.78A17.96 17.96 0 0 0 2 40zm5.38 0h9.8a17.98 17.98 0 0 0 6.67-16.42L7.4 40zm3.43-15.42v9.17l11.62-11.59c-3.97-.5-8.08.3-11.62 2.42zm32.86-.78A18 18 0 0 0 63.85 3.63L43.68 23.8zm7.2-19.17v9.15L62.43 2.22c-3.96-.5-8.05.3-11.57 2.4zm-3.49 2.72c-4.1 4.1-5.81 9.69-5.13 15.03l6.61-6.6V6.02c-.51.41-1 .85-1.48 1.33zM17.18 0H7.42L3.64 3.78A18 18 0 0 0 17.18 0zM2.08 0c-.01.8.04 1.58.14 2.37L4.59 0H2.07z'%3E%3C/path%3E%3C/svg%3E");
  background-attachment: fixed;
  box-shadow: 0 0 3px 0 #000;
  border-radius: 5px;
  margin-bottom: 55px;
  margin-top: 30px;
  padding: 15px 15px 25px;
}

.logo {
  max-height: 229px;
  max-width: 100%;
  border-radius: 0 0 5px 5px;
  padding-top: 10px;
}

.Btn {
  width: 45px;
  height: 45px;
  background: linear-gradient(#C19F5F, #c6a76d);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  border: none;
}

.arrow path {
  fill: white;
}

.text {
  font-size: 0.7em;
  width: 100px;
  position: absolute;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: -18px;
  opacity: 0;
  transition-duration: .7s;
}

.Btn:hover .text {
  opacity: 1;
  transition-duration: .7s;
}

.Btn:hover .arrow {
  animation: slide-in-bottom .7s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@keyframes slide-in-bottom {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}


.itemImage {
  height: 150px;
  max-width: 100%;
  object-fit: cover;
}

.cart {
  position: fixed;
  top: 24px;
  right: -10px;
  z-index: 9999;
}

.itemDesc {
  overflow-wrap: break-word;
  max-width: 100%;
  max-height: 90px;
  overflow: hidden;
}

.menuPosts {
  margin-top: 25px;
}

.menuPosts ul {
  width: 100%;
  text-align: center;
}

li.post {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  padding: 5px;
  margin: 3px;
  overflow: hidden;
  transition: .2s all linear;
  color: white;
  position: relative;
}

.postLinkContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 1em;
  background-color: rgba(83, 42, 40, 0.7);
  transition: .2s all linear;
  line-height: 40px;
  height: 40px;
}

.postLinkContainer:hover {
  background-color: rgba(83, 42, 40, 0.9);
}

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
  max-height: 5000px;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  max-height: 25px;
}
.vs-col select{
  padding: 15px;
  font-size: 18px;
  font-weight: 500; 
}

.select-col{
  margin-bottom:25px;
  text-align: center;
}

.breakWord {
  word-break: break-word;
}

.dailyHeader {
  text-align: center;
  padding-bottom: 15px;
}

.footer {
  text-align: center;
  margin-top: 15px;
}

p.policy {
  margin: 0 5px;
  text-align: right;
  transition: .2s all linear;
}

p.policy:hover {
  color: #90EE90;
}

.alertText {
  text-align: center;
  margin: 0;
  padding: 0;
}

.red {
  color: #f62d51;
  font-size: 17px;
}

.btn-to-top{
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
  background-color: #7a685f;
  border-color: #7a685f;
}
.btn-to-top:after{
  background-color: #7a685f;
  border-color: #7a685f;
}
.btn-to-top:hover{
  background-color: #7a685f;
  border-color: #7a685f;
}
.phone-button{
  position: fixed;
  top:10%;
  left: -115px;
  border-radius: 10px;
  transition: 0.5s;
  border-color: #532a28e6;
  z-index: 999;
  height:50px;
}

@media (hover: hover) {
  .phone-button:hover {
    left: -10px;
  }
}
</style>
<style>
@media (max-width: 768px) {
  .con-ul-tabs .ul-tabs-left {
    display: none !important;
  }
  .order-wrapper {
    width: 100% !important;
    margin-left:0px !important;
  }
  .vs-component .vs-popup{
    max-width: 100%;
    min-width:320px;
  }
}

</style>
